/**
 * Centralized icon mappings and application constants
 * All Material Symbols icon names, assets, and app-wide constants should be defined here
 */

// Application constants
export const APP_NAME = 'vHearU';
export const APP_TITLE = 'vHearU';

// VHU Logo path reference
export const VHU_LOGO = '/vhu-mmt-speechbubble.png';

export const MOMENT_ICONS = {
  // General moment icon
  MENU: 'label_important',

  // Sentiment icons
  SENTIMENT: {
    POSITIVE: 'star_shine',
    NEGATIVE: 'brightness_alert',
    NEUTRAL: 'screen_record',
  }
} as const;

/**
 * Get sentiment icon based on sentiment name
 * @param sentimentName - The name of the sentiment (optional)
 * @returns Material Symbols icon name
 */
export const getSentimentIcon = (sentimentName?: string | null): string => {
  if (!sentimentName) return MOMENT_ICONS.MENU;
  
  const name = sentimentName.toLowerCase();
  if (name.includes('positive')) return MOMENT_ICONS.SENTIMENT.POSITIVE;
  if (name.includes('negative')) return MOMENT_ICONS.SENTIMENT.NEGATIVE;
  if (name.includes('neutral')) return MOMENT_ICONS.SENTIMENT.NEUTRAL;
  return MOMENT_ICONS.MENU;
};
